// extracted by mini-css-extract-plugin
module.exports = {"text":"_3JamshfH39yKYQmVZbrwej","divider":"bgPv78bkKjqx0i3p4YnsK","confirm-button":"_3-Kv5jkfqq7-OaEk7Cc544","save-modal":"_27tmfV8AFWaK5trS1WrJ58"};